import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HighchartsChartModule} from "highcharts-angular";
import {GenericGraphComponent} from './generic-graph/generic-graph.component';
import {DialogModule} from "primeng/dialog";
import {TranslocoModule} from "@ngneat/transloco";
import {ValidationErrorsComponent} from './validation-errors/validation-errors.component';
import {ByteInputComponent} from './byte-input/byte-input.component';
import {ButtonModule} from 'primeng/button';
import {DragDropDirective} from '../../shared/drag-drop.directive';
import {DropdownModule} from "primeng/dropdown";
import {FormsModule} from "@angular/forms";
import {ExportXlsComponent} from './export-xls/export-xls.component';
import {UploadCsvComponent} from "./upload-csv/upload-csv.component";
import {RadioButtonModule} from "primeng/radiobutton";
import {InputTextModule} from "primeng/inputtext";
import {CustomCommonModule} from "../../common/common.module";

@NgModule({
  declarations: [
    GenericGraphComponent,
    ValidationErrorsComponent,
    ByteInputComponent,
    UploadCsvComponent,
    DragDropDirective,
    ExportXlsComponent
  ],
  imports: [
    CommonModule,
    HighchartsChartModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    TranslocoModule,
    FormsModule,
    RadioButtonModule,
    InputTextModule,
    CustomCommonModule
  ],
  exports: [
    GenericGraphComponent,
    ValidationErrorsComponent,
    ByteInputComponent,
    UploadCsvComponent,
    ExportXlsComponent
  ]
})
export class SharedComponentsModule {
}
